module.exports = __webpack_public_path__ + "img/PRCA2_CD8T.8813665b.png";